import { MOVE_SHEET_COLUMN } from '@/modules/move/entities/constants/moveSheetColumn';
import {
  MOVE_SHEET_BANK_ACCOUNT_TYPE,
  MOVE_SHEET_DEGREE_KINSHIP,
  MOVE_SHEET_DELETE_REASON,
  MOVE_SHEET_GENDER,
  MOVE_SHEET_MARITAL_STATUS,
  MOVE_SHEET_OWNERSHIP,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_BANK_ACCOUNT_TYPE,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_DEGREE_KINSHIP,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_DELETE_REASON,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_GENDER,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_MARITAL_STATUS,
  TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_OWNERSHIP,
} from '@/modules/move/entities/constants/moveSheetValues';
import { EditedRow } from '@/modules/move/hooks/useMoveEdition/useMoveEdition';
import { MOVE_FILE_COLUMN_NAME } from '@/pages/moves/shared/constants';

export const transformEditedRowToMoveFileColumns = (
  row: EditedRow,
  lineNumber: string,
): Record<MOVE_FILE_COLUMN_NAME, unknown> => {
  const editedRowOwnership: MOVE_SHEET_OWNERSHIP = Number(
    row.fields[MOVE_SHEET_COLUMN.titularidade],
  );
  const editedRowGender: MOVE_SHEET_GENDER = Number(row.fields[MOVE_SHEET_COLUMN.sexo]);
  const editedRowMaritalStatus: MOVE_SHEET_MARITAL_STATUS = Number(
    row.fields[MOVE_SHEET_COLUMN.estadoCivil],
  );
  const editedRowDeleteReason: MOVE_SHEET_DELETE_REASON = Number(
    row.fields[MOVE_SHEET_COLUMN.motivoDelecao],
  );
  const editedRowDegreeKinship: MOVE_SHEET_DEGREE_KINSHIP = Number(
    row.fields[MOVE_SHEET_COLUMN.grauParentesco],
  );
  const editedRowBankAccount: MOVE_SHEET_BANK_ACCOUNT_TYPE = Number(
    row.fields[MOVE_SHEET_COLUMN.tipoContaBancaria],
  );

  return {
    [MOVE_FILE_COLUMN_NAME.COLUNAS]: '',
    [MOVE_FILE_COLUMN_NAME.TITULARIDADE]:
      TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_OWNERSHIP[editedRowOwnership],
    [MOVE_FILE_COLUMN_NAME.CODIGO_DO_CONTRATO]: row.fields[MOVE_SHEET_COLUMN.contrato],
    [MOVE_FILE_COLUMN_NAME.SUBFATURA_CENTRO_DE_CUSTO]: row.fields[MOVE_SHEET_COLUMN.subfatura],
    [MOVE_FILE_COLUMN_NAME.NOME]: row.fields[MOVE_SHEET_COLUMN.nome],
    [MOVE_FILE_COLUMN_NAME.DATA_DE_NASCIMENTO]: row.fields[MOVE_SHEET_COLUMN.dataNascimento],
    [MOVE_FILE_COLUMN_NAME.MATRICULA]: row.fields[MOVE_SHEET_COLUMN.matricula],
    [MOVE_FILE_COLUMN_NAME.CPF]: row.fields[MOVE_SHEET_COLUMN.cpf],
    [MOVE_FILE_COLUMN_NAME.CPF_DO_TITULAR]: row.fields[MOVE_SHEET_COLUMN.cpfTitular],
    [MOVE_FILE_COLUMN_NAME.SEXO]: TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_GENDER[editedRowGender],
    [MOVE_FILE_COLUMN_NAME.ESTADO_CIVIL]:
      TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_MARITAL_STATUS[editedRowMaritalStatus],
    [MOVE_FILE_COLUMN_NAME.DATA_DE_INICIO_DA_VIGENCIA]:
      row.fields[MOVE_SHEET_COLUMN.dataInicioVigencia],
    [MOVE_FILE_COLUMN_NAME.NOME_DA_MAE]: row.fields[MOVE_SHEET_COLUMN.nomeMae],
    [MOVE_FILE_COLUMN_NAME.MOTIVO_DA_DELECAO]:
      TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_DELETE_REASON[editedRowDeleteReason],
    [MOVE_FILE_COLUMN_NAME.DATA_DE_CANCELAMENTO]: row.fields[MOVE_SHEET_COLUMN.dataCancelamento],
    [MOVE_FILE_COLUMN_NAME.CERTIFICADO]: row.fields[MOVE_SHEET_COLUMN.certificado],
    [MOVE_FILE_COLUMN_NAME.CODIGO_DO_DEPENDENTE]: row.fields[MOVE_SHEET_COLUMN.codDependente],
    [MOVE_FILE_COLUMN_NAME.OPCAO_PELA_RN_279]: row.fields[MOVE_SHEET_COLUMN.opcaoPelaRN279],
    [MOVE_FILE_COLUMN_NAME.GRAU_DE_PARENTESCO]:
      TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_DEGREE_KINSHIP[editedRowDegreeKinship],
    [MOVE_FILE_COLUMN_NAME.DATA_DE_CASAMENTO]: row.fields[MOVE_SHEET_COLUMN.dataCasamento],
    [MOVE_FILE_COLUMN_NAME.CODIGO_DA_ELEGIBILIDADE]: row.fields[MOVE_SHEET_COLUMN.codElegibilidade],
    [MOVE_FILE_COLUMN_NAME.EMAIL_DO_SEGURADO]: row.fields[MOVE_SHEET_COLUMN.emailSegurado],
    [MOVE_FILE_COLUMN_NAME.DATA_DE_ADMISSAO]: row.fields[MOVE_SHEET_COLUMN.dataAdmissao],
    [MOVE_FILE_COLUMN_NAME.VINCULO_COM_A_EMPRESA]: row.fields[MOVE_SHEET_COLUMN.vinculoComEmpresa],
    [MOVE_FILE_COLUMN_NAME.CEP]: row.fields[MOVE_SHEET_COLUMN.cep],
    [MOVE_FILE_COLUMN_NAME.LOGRADOURO]: row.fields[MOVE_SHEET_COLUMN.logradouro],
    [MOVE_FILE_COLUMN_NAME.BAIRRO]: row.fields[MOVE_SHEET_COLUMN.bairro],
    [MOVE_FILE_COLUMN_NAME.CIDADE]: row.fields[MOVE_SHEET_COLUMN.cidade],
    [MOVE_FILE_COLUMN_NAME.COMPLEMENTO]: row.fields[MOVE_SHEET_COLUMN.complemento],
    [MOVE_FILE_COLUMN_NAME.NUMERO]: row.fields[MOVE_SHEET_COLUMN.numero],
    [MOVE_FILE_COLUMN_NAME.UF]: row.fields[MOVE_SHEET_COLUMN.uf],
    [MOVE_FILE_COLUMN_NAME.PLANO]: row.fields[MOVE_SHEET_COLUMN.plano],
    [MOVE_FILE_COLUMN_NAME.NOME_DO_PLANO]: row.fields[MOVE_SHEET_COLUMN.nomePlano],
    [MOVE_FILE_COLUMN_NAME.TIPO_DE_CONTA_BANCARIA]:
      TRANSLATE_MOVE_SHEET_TO_FILE_COLUMN_BANK_ACCOUNT_TYPE[editedRowBankAccount],
    [MOVE_FILE_COLUMN_NAME.BANCO]: row.fields[MOVE_SHEET_COLUMN.creditoBanco],
    [MOVE_FILE_COLUMN_NAME.AGENCIA]: row.fields[MOVE_SHEET_COLUMN.creditoNumAgencia],
    [MOVE_FILE_COLUMN_NAME.DV_DA_AGENCIA]: row.fields[MOVE_SHEET_COLUMN.creditoDVAgencia],
    [MOVE_FILE_COLUMN_NAME.CONTA]: row.fields[MOVE_SHEET_COLUMN.creditoNumConta],
    [MOVE_FILE_COLUMN_NAME.DV_DA_CONTA]: row.fields[MOVE_SHEET_COLUMN.creditoDVConta],
    [MOVE_FILE_COLUMN_NAME.CODIGO_DO_ANGARIADOR]: row.fields[MOVE_SHEET_COLUMN.codAngariador],
    [MOVE_FILE_COLUMN_NAME.DATA_DA_ANGARIACAO]: row.fields[MOVE_SHEET_COLUMN.dataAngariacao],
    [MOVE_FILE_COLUMN_NAME.LOTACAO]: row.fields[MOVE_SHEET_COLUMN.lotacao],
    [MOVE_FILE_COLUMN_NAME.CNS]: row.fields[MOVE_SHEET_COLUMN.cns],
    [MOVE_FILE_COLUMN_NAME.LINHA_NO_ARQUIVO_ORIGINAL]: lineNumber,
    [MOVE_FILE_COLUMN_NAME.STATUS_DO_BENEFICIARIO]:
      row.fields[MOVE_SHEET_COLUMN.statusBeneficiario],
  };
};
